import { AxiosResponse } from "axios";
import { createApi } from "../../../../utils/createApi";
import { VpnDebugTargets } from "../vpnDebugInterfaces";

/**
 * Cameras this tunnel can reach, for the picker.
 *
 * Synchronous server-side (no SSM, no gateway round trip) and carries no
 * passwords — only `has_credentials`, which drives the form's hint.
 */
export const fetchVpnDebugTargets = async (
  tunnelId: number
): Promise<VpnDebugTargets> => {
  const AxiosUI = createApi("");
  const response: AxiosResponse<VpnDebugTargets> = await AxiosUI.get(
    `network-vpn-debug/targets/?tunnel_id=${tunnelId}`
  );
  return response.data;
};
